"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const googleStoreImage_png_1 = __importDefault(require("../img/googleStoreImage.png"));
const iOSStoreImage_png_1 = __importDefault(require("../img/iOSStoreImage.png"));
const StoreLinks = ({ androidStoreLink, iOSStoreLink, webLink, title }) => (react_1.default.createElement("div", { className: "store-links" },
    iOSStoreLink && (react_1.default.createElement("a", { href: iOSStoreLink, target: "_blank" },
        react_1.default.createElement("img", { src: iOSStoreImage_png_1.default, alt: `Download ${title} from Apple App Store`, style: { width: 135, height: 40 } }))),
    androidStoreLink && (react_1.default.createElement("a", { href: androidStoreLink, target: "_blank" },
        react_1.default.createElement("img", { src: googleStoreImage_png_1.default, alt: `Download ${title} from Google Play`, style: { width: 135, height: 40 } }))),
    webLink && (react_1.default.createElement("a", { href: webLink, alt: `${title}`, target: "_blank" },
        react_1.default.createElement("div", { className: "webLink" }, title.length < 16 ? title : "Web")))));
exports.default = StoreLinks;



// WEBPACK FOOTER //
// ./src/components/storeLinks.tsx